import Nullstack from 'nullstack';
export default function IconChartDots({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chart-dots",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 3v18h18"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "9",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "7",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "14",
    cy: "15",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "10.16",
    y1: "10.62",
    x2: "12.5",
    y2: "13.5"
  }), "   ", Nullstack.element("path", {
    d: "M15.088 13.328l2.837 -4.586"
  }), " ");
}